/* @flow */
import * as React from 'react';

// Styles
import styles from './UpcomingBraindateCard.style';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

// Utils
import { lap } from '@braindate/ui/lib/token/mediaQuery';
import { useMediaQuery } from '@mui/material';

// Components
import Card from 'src/shared/ui/component/data-display/Card';
import TopicMenu from 'src/shared/app/topic/components/TopicMenu';
import BraindateCardTitle from '../BraindateCardTitle';
import UpcomingBraindateCardDate from './UpcomingBraindateCardDate';
import UpcomingBraindateCardHeader from './UpcomingBraindateCardHeader';
import UpcomingBraindateCardFooter from './UpcomingBraindateCardFooter';

// Types
import type { Braindate } from '@braindate/domain/lib/braindate/type';

const useStyles = createUseThemeStyles(styles);

type Props = {
  braindate: Braindate,
  showCheckin?: boolean,
};

const UpcomingBraindateCard = ({ braindate, showCheckin = true }: Props) => {
  const classes = useStyles();
  const isDesktop = useMediaQuery(lap);

  return (
    <Card
      rootLayoutClass={classes.upcomingBraindate}
      disableChildrenMargin={true}
    >
      <div className={classes.card}>
        <TopicMenu
          braindate={braindate}
          classes={{
            root: classes.buttonMenuRoot,
            button: !isDesktop ? classes.buttonMenu : undefined,
          }}
        />

        <UpcomingBraindateCardDate braindate={braindate} />

        <div className={classes.content}>
          <UpcomingBraindateCardHeader braindate={braindate} />

          <BraindateCardTitle braindate={braindate} />

          <UpcomingBraindateCardFooter
            braindate={braindate}
            showCheckin={showCheckin}
          />
        </div>
      </div>
    </Card>
  );
};

export default React.memo<Props>(UpcomingBraindateCard);
